import React, { useState } from "react";
import { Alert, Badge, Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { Input } from "../../components";
import {
  bacaMasalah,
  hapusEquivalence,
  simpanEquivalence,
  ubahEquivalence,
} from "../../config/redux/action/sustainabilityAction";
import { formatAngka } from "../../utils";

const kosong = {
  id: null,
  indicator_code: "",
  label: "",
  faktor: "",
  unit_tampil: "",
  sort_order: 100,
  aktif: true,
};

function TabEquivalence({ list, indikatorList, update }) {
  const [Show, setShow] = useState(false);
  const [Form, setForm] = useState(kosong);
  const [Error, setError] = useState([]);
  const dispatch = useDispatch();

  const ubah = (key, value) => setForm({ ...Form, [key]: value });

  const buka = (baris) => {
    setError([]);
    setForm(
      baris
        ? {
            id: baris.id,
            indicator_code: baris.indicator_code,
            label: baris.label,
            faktor: baris.faktor,
            unit_tampil: baris.unit_tampil,
            sort_order: baris.sort_order,
            aktif: baris.aktif,
          }
        : kosong
    );
    setShow(true);
  };

  const simpan = () => {
    setError([]);
    // PUT bersifat replace penuh, jadi seluruh field dikirim ulang walau tidak diubah.
    const payload = {
      indicator_code: Form.indicator_code,
      label: Form.label,
      faktor: Form.faktor === "" ? undefined : Number(Form.faktor),
      unit_tampil: Form.unit_tampil,
      sort_order: Number(Form.sort_order) || 100,
      aktif: !!Form.aktif,
    };

    dispatch(
      Form.id ? ubahEquivalence(Form.id, payload) : simpanEquivalence(payload)
    )
      .then(() => {
        update();
        setShow(false);
      })
      .catch((err) => setError(bacaMasalah(err)));
  };

  const hapus = () => {
    setError([]);
    dispatch(hapusEquivalence(Form.id))
      .then(() => {
        update();
        setShow(false);
      })
      .catch((err) => setError(bacaMasalah(err)));
  };

  const dataKode = [
    { id: "", name: "— pilih kode indikator —" },
    ...(indikatorList || [])
      .filter((val, i, arr) => arr.findIndex((x) => x.code === val.code) === i)
      .map((val) => ({ id: val.code, name: `${val.code} — ${val.name_id}` })),
  ];

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-2">
        <div className="text-muted" style={{ fontSize: "11px" }}>
          Ekuivalensi mengubah angka teknis menjadi perumpamaan yang mudah dipahami
          pelanggan, misalnya liter air menjadi jumlah gelas minum.
        </div>
        <button className="btn btn-sm btn-primary" onClick={() => buka(null)}>
          Tambah Ekuivalensi
        </button>
      </div>

      <div className="table-responsive">
        <table
          className="table table-bordered align-middle mb-0"
          style={{ fontSize: "12px" }}
        >
          <thead className="table-light">
            <tr>
              <th>Indikator</th>
              <th>Label</th>
              <th className="text-end">Faktor</th>
              <th>Unit Tampil</th>
              <th className="text-center">Urutan</th>
              <th className="text-center">Aktif</th>
              <th className="text-center">Aksi</th>
            </tr>
          </thead>
          <tbody>
            {list && list.length > 0 ? (
              list.map((val) => (
                <tr key={val.id}>
                  <td className="fw-bold">{val.indicator_code}</td>
                  <td>{val.label}</td>
                  <td className="text-end">{formatAngka(val.faktor, 6)}</td>
                  <td>{val.unit_tampil}</td>
                  <td className="text-center">{val.sort_order}</td>
                  <td className="text-center">
                    <Badge bg={val.aktif ? "success" : "secondary"}>
                      {val.aktif ? "Aktif" : "Nonaktif"}
                    </Badge>
                  </td>
                  <td className="text-center">
                    <button
                      className="btn btn-sm btn-outline-secondary"
                      style={{ fontSize: "10px" }}
                      onClick={() => buka(val)}
                    >
                      Ubah
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={7} align="center">
                  Data tidak ditemukan
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <Modal show={Show} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: "16px" }}>
            {Form.id ? "Ubah Ekuivalensi" : "Tambah Ekuivalensi"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {Error.length > 0 && (
            <Alert variant="danger" style={{ fontSize: "12px" }}>
              <ul className="mb-0 ps-3">
                {Error.map((val, i) => (
                  <li key={i}>{val}</li>
                ))}
              </ul>
            </Alert>
          )}

          <Input
            judul="Kode Indikator *"
            type="select"
            data={dataKode}
            value={Form.indicator_code}
            onChange={(e) => ubah("indicator_code", e.target.value)}
          />
          <Input
            judul="Label *"
            type="text"
            placeholder="Setara gelas air minum"
            value={Form.label}
            onChange={(e) => ubah("label", e.target.value)}
          />
          <Input
            judul="Faktor *"
            type="number"
            placeholder="Pengali dari unit indikator ke unit tampil"
            value={Form.faktor}
            onChange={(e) => ubah("faktor", e.target.value)}
          />
          <Input
            judul="Unit Tampil *"
            type="text"
            placeholder="gelas"
            value={Form.unit_tampil}
            onChange={(e) => ubah("unit_tampil", e.target.value)}
          />
          <Input
            judul="Urutan"
            type="number"
            value={Form.sort_order}
            onChange={(e) => ubah("sort_order", e.target.value)}
          />
          <Input
            judul="Aktif"
            type="aktif"
            checked={!!Form.aktif}
            onChange={(e) => ubah("aktif", e.target.checked)}
          />

          <div className="d-flex justify-content-end">
            {Form.id && (
              <button className="btn btn-sm btn-danger me-2" onClick={hapus}>
                Hapus
              </button>
            )}
            <button
              className="btn btn-sm btn-secondary me-2"
              onClick={() => setShow(false)}
            >
              Batal
            </button>
            <button className="btn btn-sm btn-primary" onClick={simpan}>
              Simpan
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default TabEquivalence;
